import { Megaphone, RefreshCw, Zap, Calendar } from "lucide-react";
import { CampaignTypeDefinition } from "../components/campaigns/CampaignTypeCard";

export const CAMPAIGN_TYPES: CampaignTypeDefinition[] = [
    {
        id: "Marketing",
        title: "Marketing",
        subtitle: "Promociones y comunicación",
        description: "Ideal para campañas promocionales, lanzamientos de productos, ofertas especiales y comunicación comercial con tus clientes.",
        icon: Megaphone,
        gradient: "from-teal-500 to-cyan-500",
        bgLight: "bg-teal-50",
        bgUnselected: "bg-gradient-to-br from-teal-50/50 to-white",
        borderActive: "border-teal-400",
        borderUnselected: "border-teal-200",
        ringColor: "ring-teal-200",
        iconBg: "bg-gradient-to-br from-teal-500 to-cyan-500",
        iconBgUnselected: "bg-teal-100",
        iconColorUnselected: "text-teal-600",
        features: ["Promociones", "Ofertas", "Novedades"]
    },
    {
        id: "Renovación de servicio",
        title: "Recordatorios Periódicos",
        subtitle: "Renovación de servicio o recompra de productos",
        description: "Perfecto para enviar recordatorios de renovación, pagos pendientes, vencimientos de contratos y continuidad del servicio.",
        icon: RefreshCw,
        gradient: "from-teal-500 to-cyan-500",
        bgLight: "bg-teal-50",
        bgUnselected: "bg-gradient-to-br from-teal-50/50 to-white",
        borderActive: "border-teal-400",
        borderUnselected: "border-teal-200",
        ringColor: "ring-teal-200",
        iconBg: "bg-gradient-to-br from-teal-500 to-cyan-500",
        iconBgUnselected: "bg-teal-100",
        iconColorUnselected: "text-teal-600",
        features: ["Renovaciones", "Pagos", "Vencimientos"]
    },
    {
        id: "Dynamic",
        title: "Campaña Dinámica",
        subtitle: "Mensajes personalizados por fecha",
        description: "Configura envíos inteligentes basados en fechas específicas de tu Hoja de Cálculo. Ideal para citas, cumpleaños o vencimientos variables.",
        icon: Zap,
        gradient: "from-teal-500 to-cyan-500",
        bgLight: "bg-teal-50",
        bgUnselected: "bg-gradient-to-br from-teal-50/50 to-white",
        borderActive: "border-teal-400",
        borderUnselected: "border-teal-200",
        ringColor: "ring-teal-200",
        iconBg: "bg-gradient-to-br from-teal-500 to-cyan-500",
        iconBgUnselected: "bg-teal-100",
        iconColorUnselected: "text-teal-600",
        features: ["Fechas Variables", "Citas", "Recordatorios"]
    },
    {
        id: "Calendar",
        title: "Google Calendar",
        subtitle: "Recordatorios de eventos",
        description: "Conecta tu Google Calendar y envía recordatorios automáticos de WhatsApp a los contactos de tus eventos. Ideal para citas, reuniones y seguimientos.",
        icon: Calendar,
        gradient: "from-teal-500 to-cyan-500",
        bgLight: "bg-teal-50",
        bgUnselected: "bg-gradient-to-br from-teal-50/50 to-white",
        borderActive: "border-teal-400",
        borderUnselected: "border-teal-200",
        ringColor: "ring-teal-200",
        iconBg: "bg-gradient-to-br from-teal-500 to-cyan-500",
        iconBgUnselected: "bg-teal-100",
        iconColorUnselected: "text-teal-600",
        features: ["Google Calendar", "Recordatorios", "Automático"]
    },

];
